import { useQuery } from "@tanstack/vue-query";
import Billing from "@/services/billing/billing";

export function useBillingEstimate() {
  return useQuery({
    queryKey: ["billing", "billingEstimate"] as const,
    queryFn: async () => {
      const result = await Billing.getBillingEstimate();
      const payload = result?.data as { status?: boolean; data?: unknown };
      if (payload?.status && payload?.data != null) return payload.data;
      return null;
    },
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
}
